<template>
  <div class="w-full bg-bgnew flex flex-col h-dvh overflow-hidden" v-if="isAuth" ref="wrapper">
    <!-- header-->
    <div
      class="w-full max-md:py-2 md:h-20 shadow-[0px_8px_8px_-4px_rgba(20,16,41,0.03)] flex flex-row px-4 md:px-10 items-center justify-between bg-white flex-shrink-0"
    >
      <div v-if="!isDesktop">
        <button
          class="max-md:flex md:hidden"
          @click="isMobileMenuOpened = !isMobileMenuOpened"
          v-if="route.name !== 'index' && userModule.id"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
          >
            <rect x="4" y="8" width="20" height="1.5" rx="0.75" fill="#3A3D44" fill-opacity="0.6" />
            <rect
              x="4"
              y="18"
              width="20"
              height="1.5"
              rx="0.75"
              fill="#3A3D44"
              fill-opacity="0.6"
            />
          </svg>
        </button>
      </div>
      <div>
        <NuxtLink to="/publisher">
          <img
            src="~/assets/svg/logo.svg"
            alt="Data Light Project - publisher place"
            class="h-6 md:h-[34.5px]"
          />
        </NuxtLink>
      </div>
      <div class="flex flex-row gap-4 items-center">
        <UINewIconsIBell class="fill-txopacity md:mr-8" />

        <div class="flex flex-row gap-2 items-center cursor-pointer relative" @click="openUserMenu">
          <NuxtImg
            :src="avatar ? avatar : '/assets/img/user.png'"
            alt="logo"
            class="rounded-full md:size-12 size-8 aspect-square object-cover flex-shrink-0"
          />
          <div
            class="text-txprimary font-medium text-sm cursor-pointer hidden sm:block md:w-28 !line-clamp-1 !break-all"
          >
            {{
              (userName && userName !== "not set" && userName) ||
              telegram ||
              email ||
              "Имя пользователя"
            }}
          </div>
          <!-- <div>
            <Icon
              name="fa:chevron-down"
              class="cursor-pointer font-light text-xs text-txopacity"
              :class="{ 'rotate-180': userMenuVisible }"
            />
          </div> -->
          <Transition name="fade">
            <div
              v-if="userMenuVisible"
              class="absolute top-14 -left-24 md:left-0 md:w-full w-fit bg-black/60 rounded-lg py-2 px-4 flex flex-col gap-2 z-50"
              v-click-outside="
                () => {
                  userMenuVisible = false;
                }
              "
              @click.stop
            >
              <NuxtLink
                to="/publisher/settings"
                class="text-white cursor-pointer"
                @click="userMenuVisible = false"
                >Настройки</NuxtLink
              >
              <NuxtLink
                v-if="isAdvertiser"
                to="/orders"
                target="_blank"
                class="text-white cursor-pointer"
                @click="userMenuVisible = false"
                >Кабинет рекламодателя</NuxtLink
              >
              <div class="text-white cursor-pointer mt-7" @click="logout">Выйти</div>
            </div>
          </Transition>
        </div>
      </div>
    </div>
    <!-- main -->
    <div class="flex md:flex-row flex-col flex-1 md:h-[calc(100vh-5rem)] overflow-hidden">
      <div v-if="isDesktop" class="!w-[270px] bg-white p-10 flex-shrink-0 overflow-y-auto h-full">
        <PublisherMenuNewMenu />
      </div>
      <div class="flex-1 md:h-full min-h-0 overflow-y-auto pb-0 max-md:pb-[58px]">
        <!-- основной слот для страницы -->
        <div
          v-if="!isDesktop && isMobileMenuOpened"
          class="w-full h-full bg-white z-50 overflow-y-scroll"
        >
          <PublisherMenuNewMenu @close-menu="isMobileMenuOpened = false" />
        </div>
        <slot v-if="!isMobileMenuOpened" />
      </div>
    </div>

    <UIOverlay :view-overlay="true" />
    <ElDialog
      v-model="userModule.loginDialogVisible"
      modal-class="authorize-modal"
      width="min(500px,85vw)"
    >
      <LoginScreen />
    </ElDialog>
  </div>
  <div v-else>
    <slot />
  </div>
  <EmptyModal
    :open="showSupportChatModal"
    @update:open="showSupportChatModal = $event"
    classes="!bg-white"
    width="90%"
  >
    <SupportChatModal />
  </EmptyModal>

  <!-- Debug панель для Telegram WebView -->
  <TelegramDebugPanel />

  <!-- Мобильное меню внизу экрана -->
  <PublisherMobileBottomNav @navigate="isMobileMenuOpened = false" />
</template>
<script setup lang="ts">
  import { IconColor } from "~/interfaces/publisher";
  import { usePublisherStore } from "~/store/PublisherModule";
  import { useAppStore } from "~/store/AppModule";
  import { useChannelStore } from "~/store/ChannelModule";
  import { useAdvertContentStore } from "~/store/AdvertContentModule";
  import { useAdvertStore } from "~/store/AdvertModule";
  import dayjs from "dayjs";
  import { useScreenSize } from "~/helpers/isMobile";
  import EmptyModal from "~/components/publisher/modals/emptyModal.vue";
  import SupportChatModal from "~/components/publisher/modals/view/SupportChatModal.vue";

  const { showSupportChatModal } = storeToRefs(useAppStore());

  const { isDesktop } = useScreenSize();

  const isMobileMenuOpened = ref(false);

  const route = useRoute();

  watch(
    () => route.name,
    () => {
      // Меню перекрывает контент: без закрытия переход по нижней панели
      // выглядит так, будто нажатие не сработало
      isMobileMenuOpened.value = false;
      nextTick(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    }
  );

  const isAuth = computed(() => useCookie("authorizedP").value);

  const isTokenExpired = (token: string): boolean => {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (typeof payload.exp === 'number' && payload.exp < Date.now() / 1000) {
        return true;
      }
    } catch {
      return true;
    }
    return false;
  };

  onMounted(() => {
    if (!isAuth.value) {
      useCookie("lookingFor").value = route.fullPath as string;
      logout();
      return;
    }

    const token = isAuth.value;
    const storedAuth = localStorage.getItem("usePublisherStore__authorized");

    // Токен в куке не совпадает с localStorage или отсутствует в localStorage
    if (!storedAuth || storedAuth !== token) {
      useCookie("lookingFor").value = route.fullPath as string;
      useCookie("authorizedP").value = "";
      logout();
      window.location.href = "/publisher";
      return;
    }

    // Токен истёк
    if (isTokenExpired(token)) {
      useCookie("lookingFor").value = route.fullPath as string;
      useCookie("authorizedP").value = "";
      logout();
      window.location.href = "/publisher";
      return;
    }
  });

  // Stores
  const userModule = usePublisherStore();
  // const channelModule = useChannelStore();
  // const advertContentModule = useAdvertContentStore();
  // const appModule = useAppStore();
  // const advertModule = useAdvertStore();
  const balance = computed(() => userModule.balance);

  // Reference to a DOM element
  const wrapper = ref<HTMLElement | null>(null);

  // // Запросить токен для пользователя
  onMounted(() => {
    userModule.requestAuthKey();
  });

  const { dialogCount } = storeToRefs(userModule);

  const { roles } = storeToRefs(userModule);

  const isAdvertiser = computed(() => roles.value.includes(10));

  const userName = computed(() => userModule.name ?? null);
  const telegram = computed(() => userModule.telegram ?? null);
  const email = computed(() => userModule.email ?? null);
  const avatar = computed(() => userModule.avatar ?? null);

  const userMenuVisible = ref(false);
  const openUserMenu = () => {
    userMenuVisible.value = !userMenuVisible.value;
  };

  const logout = async () => {
    await userModule.logout();
    navigateTo("/publisher");
  };

  const timer = () => {
    const currentTime = ref(dayjs().format("HH:mm:ss"));

    setInterval(() => {
      currentTime.value = dayjs().format("HH:mm:ss");
    }, 1000);

    return currentTime.value;
  };

  onMounted(() => {
    userMenuVisible.value = false;
  });

  const routesNormalNames = computed(() => ({
    "publisher-orders": "Мои заказы",
    publisher: "Мои каналы",
    "publisher-dialogs": "Диалоги",
    "publisher-history": "История размещений",
    "publisher-places-id": "Редактирование канала",
    "publisher-payments": "Выплаты",
    "publisher-places-new": "Новый канал",
    "publisher-place-id": "Канал",
    "publisher-showcase": "Витрина",
  }));
</script>

<style lang="scss">
  .app-wrapper {
    min-height: 100dvh;
  }

  .vertical-layout {
    display: flex;
    flex-direction: row;
  }

  .page-with-top-panel {
    width: 100%;
    flex-grow: 1;
  }

  .gorizontal-menu,
  .vertical-menu {
    background: $white;
  }

  .el-menu + .screen-wrapper {
    margin-left: 70px;

    @media (max-width: $small-width) {
      margin-left: 0;
    }
  }

  .gorizontal-menu {
    @apply w-full pr-4 pl-2 z-50;
    height: 70px;

    &__aside {
      @apply h-full justify-end;

      &-user {
        width: fit-content;
        color: $light-gray;
        font-weight: 500;
      }

      &-notifications {
        width: fit-content;
        height: 100%;
        padding-left: clamp(20px, 2vw, 24px);
        padding-right: clamp(20px, 2vw, 24px);
        border-left: 1px solid rgba($main, 0.3);
        // border-right: 1px solid rgba($main, 0.3);

        @media (max-width: $small-width) {
          border: none;
        }
      }
    }

    &__button {
      cursor: pointer;
      margin: 6px 0px;
      width: 36px;
      height: 36px;
      border-radius: 11px;
      border: 1px solid rgba($main, 0.2);
      flex-direction: column;
      gap: 5px;
      padding-left: 8px;
      padding-right: 8px;

      > div {
        width: 100%;
        height: 2px;
        background: $main;
        border-radius: 1px;
      }
    }
  }

  .gorizontal-menu .gorizontal-menu__button {
    display: none;
  }

  @media (max-width: $small-width) {
    .app-wrapper .vertical-menu.vertical-menu.el-menu--collapse {
      border-right: none;

      &:not(.horizontal-collapse-transition) {
        transform: translateX(-300px);
      }

      img {
        display: none;
      }
    }

    .gorizontal-menu .gorizontal-menu__button {
      display: flex;

      + a {
        z-index: 1;
      }
    }

    .gorizontal-menu {
      justify-content: space-between;
    }

    @keyframes close {
      to {
        transform: translateX(-300px);
      }
    }

    .vertical-menu:not(.el-menu--collapse).v-leave-active {
      animation: close 0.4s ease-in;
    }
  }

  button.gorizontal-menu__aside-enter {
    @apply px-3;
    max-width: min(35vw, 8rem);
  }
</style>
